export const modalActionTypes = {
    SHOW_MODAL_DETAILS: 'SHOW_MODAL_DETAILS',
    HIDE_MODAL_DETAILS: 'HIDE_MODAL_DETAILS'
}
